<template>
  <v-dialog
    content-class="dialog-top"
    :value="value"
    max-width="400"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title
        style="background-color: #5cb860; color: white; justify-content: center;"
        class="headline py-2"
      >
        <v-icon color="white" left small>mdi-file-export</v-icon>Export to Excel
      </v-card-title>
      <v-card-text class="pt-4 pb-2 px-4">
        <v-layout row wrap class="mt-2">
          <v-flex xs12 sm6 class="pr-sm-2">
            <v-text-field
              class="pr-5"
              v-model="localStartDate"
              label="Start Date"
              type="date"
              :max="localEndDate"
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 class="pl-sm-2">
            <v-text-field
              v-model="localEndDate"
              label="End Date"
              type="date"
              :min="localStartDate"
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="mt-3">
          <v-flex xs12>
            <div class="subheading mb-2">Fields to export</div>
            <v-checkbox
              color="success"
              label="Select All"
              :input-value="areAllFieldsSelected"
              @change="toggleSelectAll"
              hide-details
              class="pb-3"
              style="transform: scale(1.05); font-weight: bold;"
            />
          </v-flex>
          <v-flex
            v-for="field in exportFields()"
            :key="field"
            xs12
            class="py-0"
          >
            <v-checkbox
              color="success"
              :label="field"
              :value="field"
              v-model="selectedFields"
              hide-details
              class="mt-0 pt-0"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat color="default" @click="$emit('input', false)"
          >Cancel</v-btn
        >
        <v-btn small color="success" :disabled="!canExport" @click="emitExport">
          <v-icon left small>mdi-download</v-icon>
          Download
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { EXCEL_EXPORT_FIELD_DEFINITIONS } from "./calendarExport";
export default {
  name: "CalendarExportDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    defaultStartDate: {
      type: String,
      default: "",
    },
    defaultEndDate: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localStartDate: "",
      localEndDate: "",
      selectedFields: [],
    };
  },
  computed: {
    canExport() {
      return (
        !!this.localStartDate &&
        !!this.localEndDate &&
        this.localStartDate <= this.localEndDate
      );
    },
    areAllFieldsSelected() {
      const fields = this.exportFields();
      return fields.length > 0 && this.selectedFields.length === fields.length;
    },
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.resetDefaults();
      }
    },
    defaultStartDate() {
      if (this.value) this.localStartDate = this.defaultStartDate;
    },
    defaultEndDate() {
      if (this.value) this.localEndDate = this.defaultEndDate;
    },
  },
  methods: {
    onFormatChange() {
      this.localStartDate = this.defaultStartDate;
      this.localEndDate = this.defaultEndDate;
    },
    resetDefaults() {
      this.localStartDate = this.defaultStartDate;
      this.localEndDate = this.defaultEndDate;
      this.selectedFields = EXCEL_EXPORT_FIELD_DEFINITIONS.filter(
        (field) => field.isDefault
      ).map((field) => field.key);
    },
    emitExport() {
      this.$emit("export", {
        selectedFields: this.selectedFields,
        startDate: this.localStartDate,
        endDate: this.localEndDate,
      });
    },
    exportFields() {
      return EXCEL_EXPORT_FIELD_DEFINITIONS.map((field) => field.key);
    },
    toggleSelectAll(isSelected) {
      this.selectedFields = isSelected ? this.exportFields() : [];
    },
  },
};
</script>
<style>
.dialog-top {
  align-self: flex-start;
  margin-top: 80px;
}
</style>
